export default __webpack_public_path__ + "static/media/1waveMotion.cb7dd423.svg";